<template>
  <div class="api_widg">
    <div class="base" data-aos="zoom-out" data-aos-duration="1000">
      <div class="nmbr">
        <div class="flexcent">
          <div>
            1<br/>2<br/>3<br/>4<br/>5<br/>6<br/>7<br/>8<br/>9<br/>10<br/>11<br/>12
          </div>
        </div>
      </div>
      <div class="code">
        {<br/>
        &nbsp;&nbsp;"channel": {<br/>
        &nbsp;&nbsp;&nbsp;&nbsp;"id": <span class="blu">"</span>
        <div class="select-container">
          <div class="dropdown">
            <div class="select" @click="toggleDropdown()">
              <span v-if="selectedDropdown === 'messenger'">
                <img src="~@/assets/img/channels/facebook_messenger.svg" width="16px" height="16px"/>
                  messenger
              </span>
              <span v-if="selectedDropdown === 'viber'">
                <img src="~@/assets/img/channels/viber.svg" width="16px" height="16px"/>
                  viber
              </span>
              <span v-if="selectedDropdown === 'mobile'">
                <img src="~@/assets/img/channels/mobile.svg" width="16px" height="16px"/>
                  mobile
              </span>
              <img src="~@/assets/img/icon_arr.svg" class="icon_arr" width="12px" height="11px" alt="">
            </div>
            <vue-slide-up-down :active="showDropdown" :duration="300" class="dropdown-list-wrapper">
              <div>
                <ul class="dropdown-list">
                  <li @click="selectDropdown('messenger')">
                    <span>
                      <img src="~@/assets/img/channels/facebook_messenger.svg" width="16px" height="16px"/>
                      messenger
                    </span>
                  </li>
                  <li @click="selectDropdown('viber')">
                    <span>
                      <img src="~@/assets/img/channels/viber.svg" width="17px" height="17px"/>
                      viber
                    </span>
                  </li>
                  <li @click="selectDropdown('mobile')">
                    <span>
                      <img src="~@/assets/img/channels/mobile.svg" width="17px" height="17px"/>
                      mobile
                    </span>
                  </li>
                </ul>
              </div>
            </vue-slide-up-down>
          </div>
        </div>
        <div class="mezeraaa"></div>
        <span class="blu"> "</span><br/>
        &nbsp;&nbsp;},<br/>
        &nbsp;&nbsp;"contact": {<br/>
        <template v-if="selectedDropdown === 'mobile'">
          &nbsp;&nbsp;&nbsp;&nbsp;"id":
          <span class="blu">"+1 (555) 857-6309"</span>
          <br/>
        </template>
        <template v-else>
          &nbsp;&nbsp;&nbsp;&nbsp;"id":
          <span class="blu">"12456789"</span>
          <br/>
        </template>
        &nbsp;&nbsp;},<br/>
        &nbsp;&nbsp;"content": {<br/>
        &nbsp;&nbsp;&nbsp;&nbsp;"type": <span class="blu">"text"</span>,<br/>
        &nbsp;&nbsp;&nbsp;&nbsp;"payload": <span class="blu">"Hello, world!"</span><br/>
        &nbsp;&nbsp;}<br/>
        }
      </div>
    </div>

    <div class="messages-wrapper msgxxx" data-aos="fade-left" data-aos-duration="800" data-aos-delay="500">
      <div class="message messenger"
           v-show="selectedDropdown === 'messenger'"
           v-bind:class="{ active: selectedDropdown === 'messenger' }">
        <div class="headpanel">
          <img src="~@/assets/img/channels/facebook_messenger.svg" width="20px" height="20px">MESSENGER
        </div>
        <div class="time">
          <div>
            9:44 AM
          </div>
        </div>
        <div class="board">
          <div class="delivered">
            <div class="pic">
              <img src="~@/assets/img/messenger_pic.png" height="33" width="35">
            </div>
            <div class="chat_bubble">
              Hello, world!
            </div>
          </div>
        </div>
      </div>

      <div class="message viber"
           v-show="selectedDropdown === 'viber'"
           v-bind:class="{ active: selectedDropdown === 'viber' }">
        <div class="headpanel">
          <img src="~@/assets/img/channels/viber.svg" width="22px" height="22px">VIBER
        </div>
        <div class="time">
          <div>
            Today
          </div>
        </div>
        <div class="board">
          <div class="delivered">
            <div class="pic">
              <img src="~@/assets/img/viber_pic.png" height="40" width="40">
            </div>
            <div class="chat_bubble">
              <img src="~@/assets/img/corner_viber.png" height="10" width="12">Hello, world!
              <div class="stamp">09:44</div>
            </div>
          </div>
        </div>
      </div>

      <div class="message mobile"
           v-show="selectedDropdown === 'mobile'"
           v-bind:class="{ active: selectedDropdown === 'mobile' }">
        <div class="headpanel">
          <img src="~@/assets/img/channels/mobile.svg" width="22px" height="22px">MOBILE
        </div>
        <div class="time">
          <div>
            Today, 15:48
          </div>
        </div>
        <div class="board">
          <div class="delivered">
            <div class="chat_bubble">
              <img src="~@/assets/img/corner_mobile.png" height="10" width="12">Hello, world!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueSlideUpDown from 'vue-slide-up-down'

  export default {
    components: {
      'vue-slide-up-down': VueSlideUpDown
    },
    data() {
      return {
        selectedDropdown: 'messenger',
        showDropdown: false
      }
    },
    methods: {
      toggleDropdown: function () {
        this.showDropdown = !this.showDropdown
      },
      selectDropdown: function (channel) {
        this.selectedDropdown = channel
        this.toggleDropdown()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .api_widg{
    position: relative;
    display: inline-block;
    vertical-align: top;
    margin-top: 3rem;
    transform: scale(0.85, 0.85) !important;
    transform-origin: left;
  }
  .api_widg .base{
    width: 436px;
    height: 313px;
    box-shadow: 15px 20px 51px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background-color: #ffffff;
    background-image: url(../../assets/img/widg_bar.jpg);
    background-position: top left;
    background-repeat: no-repeat;
    background-size:436px;
    padding-top: 40px;
  }
  .main_widg{
    width: 436px;
    height: 313px;
    box-shadow: 15px 20px 51px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #ffffff;
    position: absolute;
    z-index: 999;
    top: 33vh;
    right: 308px;
  }
  .api_widg .messages-wrapper {
    position: absolute;
    bottom: 40px;
    left: 20vw;
  }
  .nmbr{
    display: inline-block;
    height: 100%;
    width: 40px;
    background-color: #e9e3ff;

    color: #8b6aff;
    font-family: 'Roboto Mono';
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42em;
    text-align: right;
  }
  .code{
    display: inline-block;
    height: 100%;
    vertical-align: top;
    margin-top: 21px;
    color: #7f7e8c;
    font-family: 'Roboto Mono';
    font-size: 15px;
    font-weight: 500;
    line-height: 19.51px;
    padding:0 5px;
  }
  .code span.blu {
    color: #6339ff;
  }
  .flexcent{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .mezeraaa {
    display: inline-block;
    width: 163px;
  }
  .select-container{
    display: inline-block;
    position: absolute;
    background: white;
    padding: 3px 20px 6px 20px;
    border-radius: 10px;
    box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.3);
  }
  .dropdown-list {
    padding-inline-start: 25px;
    list-style-type: none;
  }
  .message {
    transform: translate(-100px);
    opacity: 0;
    transition: all .5s;
    display: block !important;
    pointer-events: none;
  }
  .message.active {
    transform: translate(0);
    opacity: 1;
    pointer-events: all;
  }
  .message {
    width: 254px;
    box-shadow: 0 10px 51px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #ffffff;
    position: absolute;
    padding-bottom: 30px;
  }
  .message .headpanel {
    width: 100%;
    height: 40px;
    background-color: #f9f8ff;
    border-radius: 10px 10px 0 0;
    display: flex;
    align-items: center;
    padding: 10px 18px;

    color: #878694;
    font-family: 'Karla';
    font-size: 15px;
    font-weight: 400;
    text-transform: uppercase;
  }
  .message .headpanel img {
    margin-right: 12px;
  }
  .message .time {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    font-size: 13px;
    font-weight: 600;
  }
  .message .board {
    padding: 0 18px;
  }
  .message .delivered > div{
    display: inline-block;
    vertical-align: top;
  }
  .message .delivered .chat_bubble{
    padding: 6px 12px 7px;
    color: #000;
    background-color: #f1f0f0;
    margin-left: 8px;
    font-size: 0.95em;
    border-radius: 20px;
  }
  .message.viber {
    background-color: #dfe0e1;
  }
  .message.viber .time > div {
    background-color: #9c9d9e;
    color: #fff;
    padding: 3px 10px;
    border-radius: 20px;
    font-weight: 700;
    font-size: 12px;
  }
  .message.viber .delivered .chat_bubble{
    padding: 7px 15px 7px;
    color: #000;
    background-color: #fafafa;
    font-size: 0.95em;
    border-radius: 13px;
    margin-left: 10px;
    margin-top: 2px;
  }
  .message.viber .delivered .chat_bubble img {
    margin-left: -20px;
    margin-top: -7px;
    position: absolute;
  }
  .message.viber .delivered .chat_bubble .stamp {
    display: inline-block;
    color: #959595;
    font-size: 12px;
    margin-left: 5px;
    vertical-align: top;
    margin-top: 3px;
  }
  .message.mobile .delivered .chat_bubble {
    background-color: #e5e5ea;
  }
  .message.mobile .delivered .chat_bubble img {
    margin-left: -16px;
    margin-top: 20px;
    position: absolute;
  }
  .select-container {
    cursor: pointer;
  }
  // iPhone Horizontal
  @media (min-width: 540px) {
    .api_widg .messages-wrapper {
      bottom: 50px;
      left: 25vw;
    }
  }
  @media (min-width: 768px) and (min-height: 1024px){
    .api_widg {
      margin-left: 5vw;
    }
  }
  // Bootstrap Large Breakpoint
  @media (min-width: 992px) {
    .api_widg .messages-wrapper {
      bottom: 220px;
      left: 50%;
    }
  }
  @media (min-width: 1111px) {
    .api_widg .messages-wrapper {
      left: 80%;
    }
  }
  @media (min-width: 1400px){
    .api_widg .messages-wrapper {
      left: 60%;
    }
  }
  @media (min-width: 1600px){
    .api_widg .messages-wrapper {
      left: 55%;
    }
  }
</style>
